<template>
  <vwc-note :header="header"><slot></slot></vwc-note>
</template>

<script>
  import '@vonage/vwc-note';

  // See description at https://vivid.vonage.com/?path=/story/composite-note--full
  export default {
    name: 'CdNote',
    props: {
      header: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  vwc-note {
    margin-bottom: 16px;
  }
</style>
